export const SET_COMMUNITY = "SET_COMMUNITY";

const community = (state = null, action) => {
  switch (action.type) {
    case SET_COMMUNITY:
      return action.payload;

    default:
      return state;
  }
};

export default community;
